export class UserLocation {
  lat: number;
  lon: number;
  city: string;
  country: string;
}
